import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
import Home from "./Pages/Homepage";
import About from "./Pages/AboutMePage/AboutMe";
import Art from "./Pages/ArtPortfolioPage/ArtPortfolio";
import CS from "./Pages/CSPortfolio/CSPortfolio";
import Pet from "./Pages/Technical Projects/Pet";
import VGDatabase from "./Pages/Technical Projects/VGDatabase";
import Student from "./Pages/Technical Projects/Student";
import Tensor from "./Pages/Technical Projects/Tensor"; 
import MyPortfolio from "./Pages/Technical Projects/MyPortfolio";


function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/art" element={<Art />} />
          <Route path="/cs" element={<CS />} />
          <Route path="/projects/Pet" element={<Pet />} />
          <Route path="/projects/vgdb" element={<VGDatabase />} />
          <Route path="/projects/student" element={<Student />} />
          <Route path="/projects/tensor" element={<Tensor />} />
          <Route path="/projects/portfolio" element={<MyPortfolio />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;

